import usePublic from './usePublicConfig';

// Resolves a card's notification badge icon from the live services list
// (Firestore-backed, same source "Our Services" renders from) instead of a
// separate hardcoded category. A card's first tagged service wins; projects
// that predate the `services` field fall back to matching their legacy
// `filterImage` filename against a service's icon.
function useServiceBadge() {
	const services = usePublic('/content/services/services.json');

	return (card) => {
		let service = services.find(s => s.id === card.services?.[0]);
		if (!service && card.filterImage) {
			service = services.find(s => s.image === card.filterImage);
		}
		return service ? `${process.env.PUBLIC_URL}/content/services/${service.image}` : undefined;
	};
}

export default useServiceBadge;
